import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { useState, useEffect } from "react";
import Hero from "./components/Hero";
import AboutMe from "./components/AboutMe";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import { BrowserRouter } from "react-router-dom";
import { Link } from "react-scroll";
import "./css/Navbar.css";

function App() {
  const [nav, setNav] = useState(false);
  const [scroll, setScroll] = useState(0);

  const handleNav = () => {
    setNav(!nav);
  };

  useEffect(() => {
    const handleScroll = () => {
      setScroll(window.pageYOffset);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const backgroundColor = scroll > 100 ? "drop-shadow-md" : "md:bg-transparent";

  return (
    <BrowserRouter>
      {/* Navbar section */}
      <div
        className={`fixed top-0 left-0 w-full flex justify-between items-center h-24 bg-white md:z-[999] z-10 mx-auto px-4 md:px-12 transition-all duration-75 ease-linear ${backgroundColor}`}
      >
        <Link
          to="hero"
          spy={true}
          offset={-200}
          smooth={true}
          duration={500}
          className="cursor-pointer"
        >
          <h1 className="text-4xl font-bold">KJW.</h1>
        </Link>
        <ul className="hidden md:flex">
          <li>
            <Link
              to="hero"
              spy={true}
              offset={-200}
              smooth={true}
              duration={500}
              className="navbar-a p-4 cursor-pointer"
            >
              Home
            </Link>
          </li>

          <li>
            <Link
              to="aboutme"
              spy={true}
              offset={-100}
              smooth={true}
              duration={500}
              className="navbar-a p-4 cursor-pointer"
            >
              About Me
            </Link>
          </li>
          <li>
            <Link
              to="projects"
              spy={true}
              offset={-100}
              smooth={true}
              duration={500}
              className="navbar-a p-4 cursor-pointer"
            >
              Projects
            </Link>
          </li>
        </ul>

        <Link
          to="contact"
          spy={true}
          offset={-100}
          smooth={true}
          duration={500}
          className="hidden md:block p-4 cursor-pointer font-bold hover:text-[#7DCE13] hover:shadow-xl transition-all duration-300"
        >
          Let's Chat!
        </Link>

        {/* handle if screen size is desktop view hamburger will hide (md:hidden)
         if screen size is mobile hamburger will display block */}

        <div onClick={handleNav} className="block md:hidden">
          {!nav ? (
            <FontAwesomeIcon className="text-3xl" icon={faBars} />
          ) : (
            <FontAwesomeIcon className="text-3xl" icon={faClose} />
          )}
        </div>

        <div
          className={
            nav
              ? "md:hidden fixed left-0 top-0 bg-amber-200 w-[60%] h-[100vh] z-10 shadow-md ease-in-out duration-500"
              : "fixed left-[-100%]"
          }
        >
          <ul className="uppercase">
            <li>
              <Link
                onClick={handleNav}
                spy={true}
                offset={-100}
                smooth={true}
                duration={500}
                className="p-6 inline-block"
                to="hero"
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                onClick={handleNav}
                spy={true}
                offset={-100}
                smooth={true}
                duration={500}
                className="p-6 inline-block"
                to="aboutme"
              >
                About Me
              </Link>
            </li>
            <li>
              <Link
                onClick={handleNav}
                spy={true}
                offset={-100}
                smooth={true}
                duration={500}
                className="p-6 inline-block"
                to="projects"
              >
                Projects
              </Link>
            </li>
            <li>
              <Link
                onClick={handleNav}
                spy={true}
                offset={-100}
                smooth={true}
                duration={500}
                className="p-6 inline-block"
                to="contact"
              >
                Let's Chat
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <Hero />
      <AboutMe />
      <Projects />
      <Contact />
      <footer className="text-center bg-black text-white p-4 mt-10">
        Created by
        <span className="font-semibold text-white">Kevin Wines </span>|
        <span> All Rights Reserved 2022</span>
      </footer>
    </BrowserRouter>
  );
}

export default App;
